export const SOCKET_NEW_BLOCK = "SOCKET_NEW_BLOCK";
export const CHANGE_ACCOUNT = "CHANGE_ACCOUNT";

export const mapStateToProps = (state) => {
  return {
    MultiAddresses: state.MultiAddresses,
    getBalance: state.getBalance,
    getSelectedAddress: state.getSelectedAddress,
    SelectedAccountInfo: state.SelectedAccount,
    AllSendersBalanceAmount: state.getAllSenderBalance,
    getTimeZone: state.timezone,
    getSocketConnection: state.getSocketConnection,
    totalAccounts: state.wallet.totalAccounts,
    selectedAccount: state.wallet.selectedAccount,
    selectedAccountName: state.wallet.selectedAccountName,
    selectedAddress: state.wallet.selectedAddress,
    endpoint: state.network.endpoint,
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    MultiAddressesFunction: async (Addresses) => {
      try {
        dispatch({ type: "MultiAddresses", data: Addresses });
      } catch (err) {
        // dispatch(logInFailed(err));
      }
    },
    SelectedAddress: async (Address) => {
      try {
        dispatch({ type: "SelectedAddress", data: Address });
      } catch (err) {
        // dispatch(logInFailed(err));
      }
    },

    SelectedAccount: async (account) => {
      try {
        dispatch({ type: "SelectedAccount", data: account });
      } catch (err) {
        // dispatch(logInFailed(err));
      }
    },

    getSelectedAccountBalance: async (Balance) => {
      try {
        dispatch({ type: "getBalance", data: Balance });
      } catch (err) {
        // dispatch(logInFailed(err));
      }
    },

    // SendBOA totalBalance of all senders
    AllSendersBalance: async (Balance) => {
      try {
        dispatch({ type: "AllSenderBalance", data: Balance });
      } catch (err) {
        // dispatch(logInFailed(err));
      }
    },

    TimeZone: async (status) => {
      try {
        dispatch({ type: "TimeZone", timeZone: status });
      } catch (err) {
        // dispatch(logInFailed(err));
      }
    },

    SocketConnection: async (status) => {
      try {
        dispatch({ type: SOCKET_NEW_BLOCK, socketConnection: status });
      } catch (err) {
        // dispatch(logInFailed(err));
      }
    },
  };
};
